import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class ReturnReq {
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    role: EmployeeRolesEnum;
    @ApiProperty()
    storeConsumptionCode: string;
    @ApiProperty()
    saleOrder: string;
    @ApiProperty()
    itemName: string;
    @ApiProperty()
    returnReasion: string;
    @ApiProperty()
    approvar:string;
    @ApiProperty()
    itemCtegory:string;
    @ApiProperty()
    remarks:string;
    @ApiProperty()
    selectedCreatedFromDate:any;
    @ApiProperty()
    selectedCreatedToDate:any;
    @ApiProperty()
    createdDate:Date;
    @ApiProperty()
    poNumber?:string;
    @ApiProperty()
    itemSubCategoryId?:string;
    @ApiProperty()
    itemId?:number;
}